function c(l, a) {
  var t = l == null ? null : typeof Symbol < "u" && l[Symbol.iterator] || l["@@iterator"];
  if (t != null) {
    var u, i, f, e, r = [], n = !0, o = !1;
    try {
      if (f = (t = t.call(l)).next, a !== 0) for (; !(n = (u = f.call(t)).done) && (r.push(u.value), r.length !== a); n = !0) ;
    } catch (y) {
      o = !0, i = y;
    } finally {
      try {
        if (!n && t.return != null && (e = t.return(), Object(e) !== e)) return;
      } finally {
        if (o) throw i;
      }
    }
    return r;
  }
}
export {
  c as default
};
